import { eEstadoDocumento } from "../common/enumModel";
import { IMaestroDocumentoCreateModel } from "../interfaces/maestro-documento/IMaestroDocumentoCreateModel";


export class MaestroDocumentoCreateModel implements IMaestroDocumentoCreateModel {
    documento: string;
    idEstado: eEstadoDocumento;

    constructor(){
        this.documento = '';
        this.idEstado = eEstadoDocumento.ACTIVO;
    }
}